<template>
  <div class="ym-score-component">
    评分<span class="score">{{ score }}</span>
    <div class="score-block" style="width: 64px; height: 10px; background-size: 64px 10px;">
      <div class="score-highlight-block"
           style="height: 10px;"
           :style="{ width: scoreWidth + 'px' }"
      ></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'YmScore',
    data() {
      return {
        scoreWidth: 0,
      };
    },
    props: {
      score: {
        type: [String, Number],
        default: '5',
      },
    },
    methods: {
      fetchScore() {
        this.scoreWidth = (128 * parseFloat(this.score)) / 5 / 2;
      },
    },
    created() {
      this.fetchScore();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .ym-score-component {
    display: flex;
    align-items: center;
    font-size: @font-size-small;
    font-weight: @font-weight-primary;
    color: @color-text-primary;
    line-height: 1;
  }

  .score {
    margin: 0 @size-extra-small 0 @size-extra-small / 2;
    font-size: @font-size-base;
    color: @color-highlight;
  }

  .score-block {
    background-image: url('@{assets-img}course/score_bg.png');
  }

  .score-highlight-block {
    height: 20px;
    background-image: url('@{assets-img}course/score_highlight_bg.png');
    background-size: cover;
  }

</style>
